export default __webpack_public_path__ + "static/media/NareshPurohit.b4580998.jpg";